module.exports = __webpack_public_path__ + "img/1544956605.6c1f3650.jpg";